import React, { useState } from "react";
import MarkdownText from "../components/MarkdownText";
import useContent from "../hooks/useContent";
import useFaqTokens from "../hooks/useFaqTokens";

/**
 * Frequently asked questions: the owner-editable `faqs` collection (bundled
 * copy until the API answers). Answers are the Markdown subset with tokens
 * filled from the service catalog and practice settings.
 */

function Item({ q, a, id }) {
  const [open, setOpen] = useState(false);
  const headerId = `${id}-q`;
  const panelId = `${id}-a`;
  return (
    <div className={`accordion-item ${open ? "open" : ""}`}>
      <h2 className="accordion-heading">
        <button
          type="button"
          id={headerId}
          className="accordion-header"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-controls={panelId}
        >
          <span>{q}</span>
          <span className="chev" aria-hidden="true">{open ? "–" : "+"}</span>
        </button>
      </h2>
      {/* Collapsed = visibility:hidden (App.css): out of the tab order and a11y tree */}
      <div
        id={panelId}
        role="region"
        aria-labelledby={headerId}
        className="accordion-panel"
        // Owner answers run to 3000 characters: room for that on a phone.
        style={{ maxHeight: open ? "4000px" : "0px" }}
      >
        {a}
      </div>
    </div>
  );
}

export default function FAQ() {
  const { items } = useContent("faqs");
  const tokens = useFaqTokens();
  return (
    <section className="section white">
      <div className="container">
        <h1>Frequently Asked Questions</h1>
        <p className="muted">Quick answers to common questions.</p>
        <div className="accordion" style={{marginTop:"1rem"}}>
          {items.map((f, i) => (
            <Item
              key={f.slug}
              id={`faq-${i}`}
              q={f.data.question}
              a={<MarkdownText source={f.data.answer} tokens={tokens} />}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
